/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { EWidgetStatus } from '../widgetTypes';
import { ISubscriberMaxCostReducer, ISubscribersMaxCost } from './widgetSubscriberMaxCostsType';

export const getSubscribeMaxCosts = (state: IRootReducer): ISubscriberMaxCostReducer =>
    state.dashboard.widgetSubscriberMaxCost;

export const makeSelectorSubscriberMaxCostsIsLoading =
    (): OutputSelector<IRootReducer, boolean, (state: ISubscriberMaxCostReducer) => boolean> =>
        createSelector(
            getSubscribeMaxCosts,
            (state: ISubscriberMaxCostReducer) => state.loading,
        );

export const makeSelectorSubscriberMaxCostsIsError =
    (): OutputSelector<IRootReducer, string, (state: ISubscriberMaxCostReducer) => string> =>
        createSelector(
            getSubscribeMaxCosts,
            (state: ISubscriberMaxCostReducer) => state.error,
        );

export const makeSelectorSubscriberMaxCostsGetSubscribers =
    (): OutputSelector<IRootReducer,
        ISubscribersMaxCost[],
        (state: ISubscriberMaxCostReducer) => ISubscribersMaxCost[]> =>
        createSelector(
            getSubscribeMaxCosts,
            (state: ISubscriberMaxCostReducer) => state.subscribers,
        );

export const makeSelectSubscriberMaxCostsStatus =
    (): OutputSelector<IRootReducer, EWidgetStatus, (state: ISubscriberMaxCostReducer) => EWidgetStatus> =>
        createSelector(
            getSubscribeMaxCosts,
            (state: ISubscriberMaxCostReducer) => state.error
                ? EWidgetStatus.ERROR
                : state.subscribers.length ? EWidgetStatus.SUCCESS : EWidgetStatus.EMPTY,
        );
